/*
  Ticket cards: add to cart without leaving the page.

  The markup is a plain form posting to /cart/add, so everything below is an
  enhancement — if this script never runs, or the request fails, the form is
  submitted normally and Shopify handles the redirect (and the error page).

  The cart drawer (assets/landing-cart-drawer.js) renders what comes back: the
  same request asks for the drawer's contents and the header's cart icon, so one
  round trip updates both, and the panel slides open on top.
*/
(() => {
  const FEEDBACK_MS = 2200;

  const flashLabel = (button, text) => {
    const label = button.querySelector('.btn__label');
    if (!label || !text) return;
    if (button.dataset.labelBefore === undefined) {
      button.dataset.labelBefore = label.textContent;
    }
    label.textContent = text;
    clearTimeout(button.feedbackTimer);
    button.feedbackTimer = setTimeout(() => {
      label.textContent = button.dataset.labelBefore;
      delete button.dataset.labelBefore;
    }, FEEDBACK_MS);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-cart-form]');
    if (!form) return;

    event.preventDefault();
    if (form.dataset.busy === 'true') return;

    const button = form.querySelector('.btn');
    const body = new FormData(form);
    // Not wanted over fetch: it only tells a normal form post where to land.
    body.delete('return_to');
    body.append('sections', 'landing-cart-drawer,cart-icon-bubble');

    form.dataset.busy = 'true';
    if (button) button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Add to cart failed');

      window.LandingCart?.render(result.sections);

      const after = form.dataset.after;
      if (after === 'cart' || after === 'checkout') {
        // Leave the spinner running: the page is on its way out.
        window.location.href = after === 'checkout' ? '/checkout' : form.dataset.cartUrl || '/cart';
        return;
      }

      if (button) flashLabel(button, form.dataset.addedLabel);
      window.LandingCart?.open();
    } catch (error) {
      // Let Shopify answer: a normal submit shows its own error page.
      form.dataset.busy = 'false';
      if (button) button.removeAttribute('aria-busy');
      form.submit();
      return;
    }

    form.dataset.busy = 'false';
    if (button) button.removeAttribute('aria-busy');
  });
})();
